import React from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { logout } from '../services/authService';
import './Sidebar.css';

function Sidebar({ user, setUser, isOpen, onClose }) {
    const navigate = useNavigate();
    const location = useLocation();

    const isProfileActive = ['/profil', '/profile', '/Profil', '/Profile'].includes(location.pathname);

    const handleLogout = () => {
        if (setUser) setUser(null);
        logout();
        localStorage.removeItem('user');
        navigate('/login');
    };

    // Mobilde bir linke tıklanınca çekmece otomatik kapansın
    const handleLinkClick = () => {
        if (onClose) onClose();
    };

    return (
        <>
            {/* Mobilde sidebar açıkken arkayı karartan, tıklanınca kapatan katman */}
            {isOpen && <div className="sidebar-backdrop" onClick={onClose}></div>}

            <nav className={`sidebar ${isOpen ? 'sidebar--open' : ''}`}>
                <ul className="nav-menu">
                    <li>
                        <NavLink to="/" onClick={handleLinkClick} className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                            <span className="nav-name">Home</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/Sohbet" onClick={handleLinkClick} className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                            <span className="nav-name">Sohbet</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/Code" onClick={handleLinkClick} className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                            <span className="nav-name">Code</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/Kaydedilenler" onClick={handleLinkClick} className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                            <span className="nav-name">Kaydedilenler</span>
                        </NavLink>
                    </li>
                </ul>

                {user && (
                    <div className="sidebar-bottom">
                        <NavLink 
                            to="/profil" 
                            onClick={handleLinkClick}
                            className={`nav-link ${isProfileActive ? 'active' : ''}`}
                        >
                            <span className="nav-name">Profil</span>
                        </NavLink>
                        
                        <button onClick={() => { handleLogout(); handleLinkClick(); }} className="nav-link logout-button">
                            <span className="nav-name">Çıkış Yap</span>
                        </button>
                    </div>
                )}
            </nav>
        </>
    );
}

export default Sidebar;